import { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import ChatbotTable from '../../components/comman/ChatBotTable';
import Card from "../../components/comman/CountCards";
import cards from './JSON/cards.json';
import { useNavigate } from "react-router-dom";
import CommonModal from "../../components/comman/modal/Modal";
import CardTypeForm from "../../components/chatbots/CardsForm";
import { fetchCards, addCard, updateCard, deleteCard } from "../../redux/actions/chatbotActions/cardActions";
import CardViewData from "../../components/chatbots/CardViewData";
import ConfirmationModal from "../../components/chatbots/ConfirmationModal";
import { fetchCountries } from "../../redux/actions/chatbotActions/countryActions";
import { fetchCategories } from "../../redux/actions/chatbotActions/categoryActions";
import { fetchChatbotOfferings } from "../../redux/actions/chatbotActions/offering.actions";
import CardSection from "./CardSection";



const CardTypeSection = () => {
  const dispatch = useDispatch();
  const { cardTypes } = useSelector(state => ({
    cardTypes: state.cardReducer?.cards?.data,
  }), shallowEqual);

  const [activeCardId, setActiveCardId] = useState("card");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState("add"); // add, edit, view
  const [selectedCard, setSelectedCard] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedCardToDelete, setSelectedCardToDelete] = useState(null);



  const columns = [
    { key: "id", label: "ID", width: "40%" },
    { key: "card_holder", label: "Card Holder", width: "30%" },
    { key: "tier", label: "Card Tier", width: "20%" },
    { key: "status", label: "Status", width: "10%" }
  ];




  // Open modal for add/edit/view
  const openModal = (type, card = null) => {
    setModalType(type);
    setSelectedCard(card);
    setModalOpen(true);
  };

  const handleFormSubmit = (formData) => {
    const { cards } = formData;
    if (modalType === "edit") {
      //if only one
      dispatch(updateCard(selectedCard.id, cards[0]));
    } else if (modalType === "add") {

      //if more than one
      if (cards?.length > 1) {
        dispatch(addCard(cards));
      } else {
        //if only one
        dispatch(addCard([cards[0]]));
      }
    }
    setModalOpen(false);
  };

  const handleView = (card) => {
    openModal("view", card);
  };

  const handleDeleteClick = (card) => {
    setSelectedCardToDelete(card);
    setConfirmOpen(true);
  };

  const handleConfirmDelete = () => {
    if (selectedCardToDelete) {
      dispatch(deleteCard(selectedCardToDelete.id));
      setConfirmOpen(false);
      setSelectedCardToDelete(null);
    }
  };

  const handleStatusClick = (card) => {
    dispatch(updateCard(card.id, { status: card.status === 1 ? 0 : 1 }));
  };

  return (
    <div className="content-chatbot">
      <h1 className="text-3xl font-bold mb-8 text-gray-800">
        Card Type Management
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
        <CardSection />
      </div>

      {activeCardId === "card" && (
        <ChatbotTable
          title="Card Type"
          columns={columns}
          data={cardTypes || []}
          btnName="Add New Card Type"
          onAdd={() => openModal("add")}
          onView={handleView}
          onEdit={(card) => openModal("edit", card)}
          onDelete={handleDeleteClick}
          handleStatusClick={handleStatusClick}
        />
      )}

      <CommonModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        title={
          modalType === "add"
            ? "Add New Card Type"
            : modalType === "edit"
              ? "Edit Card Type"
              : "Card Type Details"
        }
      >
        {modalType === "view" ? (
          <CardViewData selectedCard={selectedCard} />
        ) : (
          <CardTypeForm
            onSubmit={handleFormSubmit}
            initialData={selectedCard}
            updateData={selectedCard}
            hidebtn={modalType === "edit"}
            btnName={modalType === "add" ? "Add Card" : "Update Card"}
          />
        )}
      </CommonModal>

      <ConfirmationModal
        isOpen={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={handleConfirmDelete}
        title="Delete Card"
        message={`Are you sure you want to delete this card?`}
        data={selectedCardToDelete}
      />
    </div>
  );
};

export default CardTypeSection;
